import { render, staticRenderFns } from "./attm_button.vue?vue&type=template&id=59199ab7&scoped=true"
import script from "./attm_button.vue?vue&type=script&lang=js"
export * from "./attm_button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59199ab7",
  null
  
)

export default component.exports